import Image from "next/image";
import React, { useState } from "react";
import { Button, FormText } from "react-bootstrap";
import { useDispatch } from "react-redux";
import Api from "src/data/api";
import axios from "axios";
import { showNotification } from "src/redux/notificationActions";
import { ERROR_MESSAGES, SETTINGS_MESSAGES } from "src/constants/messages";
import { NOTIFICATION_TYPES } from "src/constants/notificationTypes";
import { NOTIFICATION_HEADERS } from "src/constants/notificationHeaders";

const WidgetImageUploadForm = ({ widgetImg }) => {
    const dispatch = useDispatch();
    const [imgSrc, setImgSrc] = useState(widgetImg || "");

    const uploadImage = async (data) => {
        const imageName = data.name;

        try {
            const res = await Api.request({
                method: "GET",
                url: `/retailer/settings/widget-image/upload-url`,
                params: { imageName },
            });

            const { uploadUrl } = res.data;

            await axios.put(uploadUrl, data);
            const downloadUrl = uploadUrl.split("?")[0];

            await Api.request({
                method: "POST",
                url: "/retailer/settings/widget-image",
                data: { downloadUrl, imageName: res.data.imageName },
            });

            dispatch(
                showNotification(
                    SETTINGS_MESSAGES.UPDATE_WIDGET_IMAGE_SUCCESS,
                    NOTIFICATION_TYPES.SUCCESS,
                    NOTIFICATION_HEADERS.RETAILER_WIDGET_SETTINGS
                )
            );
        } catch (err) {
            console.log(err);
            dispatch(
                showNotification(
                    ERROR_MESSAGES.SOMETHING_WENT_WRONG,
                    NOTIFICATION_TYPES.ERROR,
                    NOTIFICATION_HEADERS.OOPS
                )
            );
        }
    };

    return (
        <>
            <h3 style={{ marginTop: 15 }}>Logo</h3>
            <FormText muted>
                The image should be 200 by 200 pixels with a transparent
                background. This logo appears in the booking confirmation emails
                sent to shoppers.
            </FormText>
            <div
                style={{
                    width: 200,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Image
                    loader={() => {
                        return (
                            imgSrc ||
                            "https://toteapp-emails.s3.amazonaws.com/tote-app-logo.svg"
                        );
                    }}
                    width={200}
                    height={200}
                    src={
                        imgSrc ||
                        "https://toteapp-emails.s3.amazonaws.com/tote-app-logo.svg"
                    }
                    alt="retailer widget image"
                    unoptimized
                />

                <Button style={{ marginTop: 10 }} className="mb-4">
                    <label style={{ margin: 0 }} htmlFor="upload-widget-image">
                        Replace Image
                    </label>
                    <input
                        id="upload-widget-image"
                        type="file"
                        onChange={(e) => {
                            setImgSrc(URL.createObjectURL(e.target.files[0]));
                            uploadImage(e.target.files[0]);
                        }}
                        style={{ display: "none" }}
                    />
                </Button>
            </div>
        </>
    );
};

export default WidgetImageUploadForm;
